var commmonWebConfig = {
	//本地环境
//	webCommonUtils : '//172.16.8.29/allProgress/static/trunk/webCommonUtils/dest',
	//王欢本地环境
//  tuanchehuan:'//172.16.3.113:8080/tuanche-shareApi'
	/*图片路径*/
	//测试环境
	static:"//static.tuanche.com/wap2017/dist",
	staticWap02:"//static.tuanche.com/wap02/dist",
	staticWap01:"//static.tuanche.com/wap01/dist",
	webCommonUtils:"//static.tuanche.com/webCommonUtils/dest",
//  webCommonUtils:"//172.16.3.24/truck/webCommonUtils/dest",
	picHost:"//pic.tuanche.com",
	tuancheapi:"//api.tuanche.com",
//	tuancheapi:"//api.tuanche.com",
//	tuancheurlapi:"//m.tuanche.com",
//	tuancheapi:"//172.16.3.138:80"
	//comparisonapi:"//172.16.60.12:7113"
    //预发布环境
//  static:"//static.tuanche.com/wap2017/dist",
//	staticWap02:"//static.tuanche.com/wap02/dist",
//	staticWap01:"//static.tuanche.com/wap01/dist",
//	webCommonUtils : '//static.tuanche.com/webCommonUtils/dest',
//	picHost:"//pic.tuanche.com",
	/*接口路径*/
//	tuancheapi:"//api.tuanche.com",
//头条报名接口路径
//测试环境
//	tuancheapi:"//api.tuanche.com/distribute",

	
}



export default commmonWebConfig


// WEBPACK FOOTER //
// ./src/utils/config.js